import CollectionInterface from 'app/interfaces/CollectionInterface';

export const selectPickerCollection = (values: string[][]): CollectionInterface[] => values
    .map(([key, value]: string[]): CollectionInterface => ({
        text: key,
        value
    }));
